

// export default function StepIndicator({
//   currentStep,
//   maxSteps,
// }) {
//   return (
//     <div className="flex items-center justify-center gap-2">
//       {Array.from({ length: maxSteps }, (_, i) => i + 1).map((step) => (
//         <div key={step} className="flex items-center">
//           <div
//             className={`w-10 h-10 rounded-full flex items-center justify-center font-semibold transition-colors ${
//               step <= currentStep
//                 ? 'bg-primary text-white'
//                 : 'bg-gray-200 text-gray-600'
//             }`}
//           >
//             {step}
//           </div>
//           {step < maxSteps && (
//             <div
//               className={`w-12 h-1 mx-2 transition-colors ${
//                 step < currentStep ? 'bg-primary' : 'bg-gray-200'
//               }`}
//             />
//           )}
//         </div>
//       ))}
//     </div>
//   );
// }

export default function StepIndicator({ currentStep, maxSteps }) {
  return (
    <div className="w-full overflow-hidden">
      <div className="flex items-center justify-center gap-1 px-1">
        {Array.from({ length: maxSteps }, (_, i) => i + 1).map((step) => (
          <div key={step} className="flex items-center min-w-0">
            <div
              className={`rounded-full flex items-center justify-center font-semibold transition-colors
              w-8 h-8 text-sm sm:w-10 sm:h-10 sm:text-base ${
                step <= currentStep
                  ? 'bg-primary text-white'
                  : 'bg-gray-200 text-gray-600'
              }`}
            >
              {step}
            </div>

            {step < maxSteps && (
              <div
                className={`mx-1 sm:mx-2 transition-colors
                w-6 sm:w-12 h-1 ${
                  step < currentStep ? 'bg-primary' : 'bg-gray-200'
                }`}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
